module.exports = __webpack_public_path__ + "static/first-25f59ac69da6ab1786d9506f19cb4a9e.svg";